import React, { useEffect, useContext } from 'react';
import { ContextSindico } from '../../../../services/sindico';

import { ContextSolicitacoes } from '../../../../services/solicitacoes';

import DropDown from '../../../Reutilizaveis/DropDown';

const HorarioAgendamento = ({
  setDiasDisponiveis,
  setHorarioSelecionado,
  dataParaAgendamento,
  horariosDisponiveis,
  setHorariosDisponiveis,
  setAgentes,
  tipoAtendimentoSolicitacao,
  isSindico,
}) => {
  const { periodoAgente } = useContext(
    isSindico ? ContextSindico : ContextSolicitacoes
  );

  useEffect(() => {
    //   loadTurnosDisponiveis();
    // else
    (async function () {
      await loadPeriodoAgente();
    })();
  }, [dataParaAgendamento]);

  // const loadTurnosDisponiveis = () => {
  //   let turnos = periodoAgente.filte;
  // };

  async function loadPeriodoAgente() {
    let diasDisponiveisParaAgendamento = [];

    let diasComHorario = [];

    periodoAgente.forEach((dia) => {
      if (dia.intervals.length > 0) {
        diasDisponiveisParaAgendamento.push(dia.date_x);
        diasComHorario.push(dia);
      }
    });

    let diasDropDown = [];

    let totalDaysToSchedule =
      diasDisponiveisParaAgendamento?.length > 5
        ? 5
        : diasDisponiveisParaAgendamento?.length;

    for (let i = 0; i < totalDaysToSchedule; i++) {
      diasDropDown.push({
        nome: diasDisponiveisParaAgendamento[i].split('-').reverse().join('/'),
      });
    }

    setDiasDisponiveis(diasDropDown);

    setAgentes(
      periodoAgente.filter(
        (agente) =>
          agente.date_x.toString() ==
          dataParaAgendamento.split('/').reverse().join('-')
      )
    );

    filtraHorarioParaDiaSelecionado(diasComHorario);
  }

  const filtraHorarioParaDiaSelecionado = (diasComHorario) => {
    if (dataParaAgendamento) {
      let tempDiasHorariosDisponiveis = '';
      let tempDataParaAgendamento = dataParaAgendamento
        .split('/')
        .reverse()
        .join('-');
      // if (tipoAtendimentoSolicitacao === "Assistência Técnica") {
      //   tempDiasHorariosDisponiveis = diasComHorario.find(
      //     (dia) => dia.date_x === tempDataParaAgendamento
      //   );
      // } else {
      tempDiasHorariosDisponiveis = diasComHorario.find(
        (dia) => dia.date_x === tempDataParaAgendamento
      );
      // }

      montaArrayParaDropdown(tempDiasHorariosDisponiveis.intervals);
      return tempDiasHorariosDisponiveis.intervals;
    }
  };

  const montaArrayParaDropdown = (arrayHorarios) => {
    let temp = [];
    if (tipoAtendimentoSolicitacao === 'Assistência Técnica') {
      arrayHorarios.forEach((horario) => {
        if (temp.findIndex((t) => t.nome === horario?.interval.turno) === -1)
          temp.push({ nome: `${horario.interval.turno}` });
      });

      setHorariosDisponiveis(temp);
    } else {
      arrayHorarios.forEach((horario) => {
        temp.push({ nome: `${horario.interval.turno} - ${horario.label}` });
      });
      setHorariosDisponiveis(temp);
    }
  };

  return (
    <div style={{ margin: '60px 0px' }}>
      <DropDown
        itens={horariosDisponiveis}
        idDropDown='dropDownHorarios'
        setValue={setHorarioSelecionado}
        label='Selecione o melhor horário para seu atendimento:'
        nomeDropDown='Horário'
        obrigatorio='true'
        alturaMinima='120px'
        overflow='hidden'
        widthMeuImovel='100%'
        marginLeftMeuImovel='0px'
        btnClose={false}
        desabilitado={dataParaAgendamento == ''}
      />
    </div>
  );
};

export default HorarioAgendamento;
